var map = {
	"./Picture1.png": 4632,
	"./Picture1.svg": 662,
	"./Picture2.png": 2249,
	"./booke1.png": 5304,
	"./booke2.jpeg": 8123,
	"./books.svg": 4170,
	"./bree.webp": 2348,
	"./close.png": 1460,
	"./committee-1.png": 1777,
	"./committee-10.png": 3821,
	"./committee-11.png": 4128,
	"./committee-12.png": 3537,
	"./committee-13.png": 2383,
	"./committee-14.png": 7807,
	"./committee-15.png": 4421,
	"./committee-16.png": 1392,
	"./committee-2.png": 8827,
	"./committee-3.png": 7036,
	"./committee-4.png": 1834,
	"./committee-5.png": 9137,
	"./committee-6.png": 8721,
	"./committee-7.png": 8531,
	"./committee-8.png": 588,
	"./committee-9.png": 4341,
	"./hotel.png": 9341,
	"./logo.png": 6949,
	"./pa1.png": 8279,
	"./pa10.png": 1673,
	"./pa11.png": 4847,
	"./pa12.png": 7562,
	"./pa2.png": 4366,
	"./pa3.png": 5466,
	"./pa4.png": 503,
	"./pa5.png": 5768,
	"./pa6.png": 3607,
	"./pa7.png": 9013,
	"./pa8.png": 3815,
	"./pa9.png": 1767,
	"./pause.png": 1068,
	"./play.png": 5093,
	"./profile_tree1.svg": 6285,
	"./profile_tree10.svg": 4889,
	"./profile_tree11.svg": 1311,
	"./profile_tree2.svg": 6088,
	"./profile_tree3.svg": 5367,
	"./profile_tree4.svg": 1423,
	"./profile_tree5.svg": 1435,
	"./profile_tree6.svg": 7990,
	"./profile_tree7.svg": 7417,
	"./profile_tree8.svg": 4963,
	"./profile_tree9.svg": 4803,
	"./reunion.png": 8588,
	"./shirt.jpg": 9916,
	"./sjslogo-curve.svg": 3914,
	"./sjslogo.svg": 9456,
	"./sjslogo2.svg": 1262,
	"./sjslogo_update.svg": 8348,
	"./stop.png": 8538,
	"./test-audio.mp3": 3428,
	"./test.svg": 4895,
	"./tree.svg": 8738,
	"./tree2.svg": 7788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;